import { getClientPortalHost } from './get-client-portal-host';
import { getClientVendorCode } from './get-client-vendor-code';
export var getVendorCode = function() {
    var vendorCodeFromStorage = sessionStorage.getItem('VendorCode');
    if (vendorCodeFromStorage) {
        return vendorCodeFromStorage;
    } else {
        var clientPortalHost = getClientPortalHost();
        var vendorCode = getClientVendorCode(clientPortalHost || window.location.hostname);
        sessionStorage.setItem('VendorCode', vendorCode);
        return vendorCode;
    }
};
